module.exports = __webpack_public_path__ + "static/media/Thank You-1-mob.1176a74c.jpg";